'use client';

import clsx from 'clsx';
import { useRef } from 'react';

type DiscoverMoreButtonProps = {
  isSearchBannerPlacedBeforeImage: boolean;
};

export const DiscoverMoreButton: React.FC<DiscoverMoreButtonProps> = ({ isSearchBannerPlacedBeforeImage }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const scrollDown = () => {
    const nextSection = buttonRef.current?.closest('section')?.nextElementSibling;
    if (nextSection && 'offsetTop' in nextSection && typeof nextSection.offsetTop === 'number') {
      return window.scrollTo({ top: nextSection.offsetTop, behavior: 'smooth' });
    }
    window.scrollTo({ top: document.querySelector('footer')?.offsetTop ?? 0, behavior: 'smooth' });
  };

  return (
    <button
      ref={buttonRef}
      className={clsx(
        'relative z-[2] mt-6 flex translate-y-0 flex-row items-center justify-center  gap-4 text-black transition-all duration-300 hover:-translate-y-1 hover:fill-elty-green hover:text-elty-green focus:-translate-y-1 focus:fill-elty-green focus:text-elty-green lg:top-0 lg:mb-28 lg:ml-20  lg:justify-start xl:mx-auto xl:w-full xl:max-w-screen-xl',
        !isSearchBannerPlacedBeforeImage && '-top-14 -mb-2 md:-top-40 md:-mb-24',
      )}
      onClick={scrollDown}
    >
      <span>Scopri di più</span>
      <svg
        className="fill-inherit"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="scroll down icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1919 0.933058C14.436 1.17714 14.436 1.57286 14.1919 1.81694L7.94194 8.06694C7.69786 8.31102 7.30214 8.31102 7.05806 8.06694L0.808058 1.81694C0.563981 1.57286 0.563981 1.17714 0.808058 0.933059C1.05214 0.688981 1.44786 0.688981 1.69194 0.933059L7.5 6.74112L13.3081 0.933058C13.5521 0.688981 13.9479 0.688981 14.1919 0.933058ZM14.1919 5.93306C14.436 6.17714 14.436 6.57286 14.1919 6.81694L7.94194 13.0669C7.69786 13.311 7.30214 13.311 7.05806 13.0669L0.808058 6.81694C0.563981 6.57286 0.563981 6.17714 0.808058 5.93306C1.05214 5.68898 1.44786 5.68898 1.69194 5.93306L7.5 11.7411L13.3081 5.93306C13.5521 5.68898 13.9479 5.68898 14.1919 5.93306Z"
        />
      </svg>
    </button>
  );
};
